/**
 * Returns a deeply cloned object or array without reference, handling circular references and special object types.
 *
 * @param {any} obj - The object or array to be cloned.
 * @param {WeakMap} seen - Internal use to track already visited objects to handle circular references.
 * @returns {any} A new clone of the input object or array.
 */
const deepClone = function (obj, seen = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') {
    // Primitive types and null are returned directly.
    return obj;
  }

  if (seen.has(obj)) {
    // If already visited, return the clone from the map to handle circular references.
    return seen.get(obj);
  }

  let clone;
  if (Array.isArray(obj)) {
    clone = [];
  } else if (obj instanceof Date) {
    clone = new Date(obj);
  } else if (obj instanceof RegExp) {
    clone = new RegExp(obj);
  } else {
    clone = {};
  }

  // Add the object to the map before recursion to break the circle.
  seen.set(obj, clone);

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      clone[key] = deepClone(obj[key], seen);
    }
  }

  return clone;
};

export default deepClone;
